import { useQuery } from '@tanstack/react-query';
import { queryKeys, instancesService } from '@v2/services';
import type { ClientManifest } from '@v2/types';

interface UseInstanceManifestResult {
  manifest: ClientManifest | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useInstanceManifest = (
  instanceId: string | null | undefined,
): UseInstanceManifestResult => {
  const query = useQuery({
    queryKey: queryKeys.instances.manifest(instanceId ?? ''),
    queryFn: () => instancesService.getClientManifest(instanceId ?? ''),
    enabled: !!instanceId,
  });

  return {
    manifest: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
};

export default useInstanceManifest;
